import { Papybase } from '@luxtag/papybase';
import papybaseConfig from './papybaseConfig';

const papybase = Papybase.initializeApp(papybaseConfig);
const auth = papybase.auth();
const user = papybase.user();
const certificate = papybase.certificate();
const product = papybase.product();
const upload = papybase.upload();
const industry = papybase.industry();
const goal = papybase.goal();
const transaction = papybase.transaction();
const source = papybase.source();
const geoIP = papybase.geoIP();
const order = papybase.order();
const uuid = papybase.uuid();

export {
    auth, user, certificate, product, industry, goal, upload, source, transaction, geoIP, order, uuid,
};
